import React from 'react';
import { Mail } from 'lucide-react';
import PropTypes from "prop-types";

import { isValidEmail } from '../../../Utils/DataValidationUtils';

import './Input.scss';

export default function EmailInputBox(props) {
  const { email = '', setEmail, placeholder = 'Enter Email Address', hasEmailError = false, setHasEmailError = () => {}, 
  showIcon = true, disabled = false,onBlur = () => {}
  } = props;

  const onChangeEmail = (e) => {
    if (disabled) return;
    const val = e.target.value;
    setHasEmailError(isValidEmail(val) ? false : true);
    setEmail(val);
  }

  return (
    <div className={`pos_relative inputWrapper ${disabled ? "disabledInputWrapper" : ""}`}>
      {showIcon && <Mail />}

      <input
        value={email}
        placeholder={placeholder}
        onChange={onChangeEmail}
        className={hasEmailError ? "inputErrorBox" : ''}
        disabled={disabled}
        onBlur={onBlur}
      />

      <div className='error'>{hasEmailError ? 'Please enter valid email address *' : ''}</div>
    </div>
  );
};

EmailInputBox.propTypes = {
  email: PropTypes.string,
  setEmail: PropTypes.func,
  placeholder: PropTypes.string,
  hasEmailError: PropTypes.bool,
  setHasEmailError: PropTypes.func,
  showIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
};